export const limitWords = (str, num) => {
  const words = str.split(' ')
  if (words.length <= num) {
    return str
  }
  return words.slice(0, num).join(' ') + ' ...'
}

export const extractFirstImage = (content) => {
  if (!content) return '/images/tl_logo_meta.png'

  const regex = /<img[^>]+src="([^">]+)"/g
  const match = regex.exec(content)

  if (match && match[1]) {
    // Handle both www and content subdomains
    const imageUrl = match[1].replace('www.talentlift.ca', 'content.talentlift.ca')

    // Validate the URL
    try {
      new URL(imageUrl)
      return imageUrl
    } catch (e) {
      console.error('Invalid image URL:', imageUrl)
      return '/images/tl_logo_meta.png'
    }
  }

  return '/images/tl_logo_meta.png'
}

export const roundIt = (num) => {
  const remainder = num % 1000

  if (remainder === 0) {
    return num.toLocaleString('en-US')
  } else {
    let result = Math.floor(num / 1000) * 1000
    result = result.toLocaleString('en-US')
    return result
  }
}

export const decodeHTMLEntities = (text) => {
  if (!text) return ''

  return text
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec)) // Decode numeric entities
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&ndash;/g, '–')
    .replace(/&mdash;/g, '—')
    .replace(/&hellip;/g, '…')
}
